import { computed, inject, Injectable, resource } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ProofCtBatch } from '../model/ct-batch-model';
import { AuditChatApiService } from './audit-chat-api.service';
import { catchError, firstValueFrom, of } from 'rxjs';
import { SharedCtBatchStoreService } from '../store/shared-ct-batch-store.service';

@Injectable({
  providedIn: 'root',
})
export class AuditChatMessageService {
  private readonly ctBatchService = inject(SharedCtBatchStoreService);
  private readonly auditChatApiService = inject(AuditChatApiService);

  private readonly ctBatch = toSignal(this.ctBatchService.ctBatch);

  private readonly chatMessages = resource({
    params: () => ({ auditId: (this.ctBatch() as ProofCtBatch)?.auditId }),
    loader: async ({ params: { auditId } }) =>
      auditId
        ? firstValueFrom(
            this.auditChatApiService.getAuditChatMessages(auditId).pipe(
              catchError(() => {
                console.error('failed to fetch messages');
                return of([]);
              }),
            ),
          )
        : undefined,
  });

  readonly messages = computed(() => this.chatMessages.value() ?? []);
}
